<template>
  <Teleport to="body">
    <Transition name="session-expired-overlay">
      <div
        v-if="show"
        ref="rootEl"
        tabindex="-1"
        class="session-expired-modal"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="session-expired-modal-title"
        aria-describedby="session-expired-modal-desc"
        @keydown.esc.prevent="onSignInAgain"
      >
        <div class="session-expired-modal__backdrop" aria-hidden="true" />
        <Transition name="session-expired-panel" appear>
          <div
            v-if="show"
            class="session-expired-modal__panel"
            @click.stop
          >
            <div class="session-expired-modal__icon-wrap" aria-hidden="true">
              <i class="bi bi-shield-lock" />
            </div>
            <h2 id="session-expired-modal-title" class="session-expired-modal__title">Session expired</h2>
            <p id="session-expired-modal-desc" class="session-expired-modal__text">
              Your sign-in timed out for security. Sign in again to keep working.
            </p>
            <div class="session-expired-modal__actions">
              <PrimaryButton
                label="Sign in again"
                icon="bi bi-box-arrow-in-right"
                @click="onSignInAgain"
              />
            </div>
          </div>
        </Transition>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import PrimaryButton from '@/modules/consultant/components/PrimaryButton.vue';

export default {
  name: 'SessionExpiredModal',
  components: {
    PrimaryButton
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  emits: ['sign-in-again'],
  watch: {
    show(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.rootEl?.focus?.();
        });
      }
    }
  },
  methods: {
    onSignInAgain() {
      this.$emit('sign-in-again');
    }
  }
};
</script>

<style scoped src="./SessionExpiredModal.css"></style>
